import ProposalType from '../proposal-type.enum';

export const getTypeFromId = (proposalId: string | undefined): ProposalType | null => {
  const type = proposalId
    ?.split('-')
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join('');

  if (!type) {
    return null;
  }

  return ProposalType[type as keyof typeof ProposalType] ?? null;
};
